import React from "react";
import { motion } from "framer-motion";
import {
  UserCheck,
  FileSpreadsheet,
  ArrowRight,
  CheckCircle2,
} from "lucide-react";

export const Inscripcion = (props) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <section className="w-full max-w-6xl mx-auto py-24">
      <div className="text-center mb-10">
        <div
          className="      btn-primary "
          dangerouslySetInnerHTML={{
            __html: props.titulo,
          }}
        />
      </div>

      <motion.div
        className="grid md:grid-cols-2 gap-8 items-stretch"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
      >
        {/* Card 1: Como Asistente */}
        <motion.div
          variants={cardVariants}
          whileHover={{ y: -6 }}
          className="relative  p-8 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 group"
        >
          <div>
            <div className="inline-flex items-center justify-center p-3 bg-blue-50 text-blue-600 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
              <UserCheck className="w-7 h-7" />
            </div>
            <div
              className="      btn-primary "
              dangerouslySetInnerHTML={{
                __html: props.bloque1,
              }}
            />
           
          </div>
 
        </motion.div>

    
        <motion.div
          variants={cardVariants}
          whileHover={{ y: -6 }}
          className="relative   p-8 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 group"
        >
          <div>
            <div className="inline-flex items-center justify-center p-3 bg-amber-50 text-amber-600 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
              <FileSpreadsheet className="w-7 h-7" />
            </div>

            <div
              className="      btn-primary "
              dangerouslySetInnerHTML={{
                __html: props.bloque2,
              }}
            />

           
          </div>
 
        </motion.div>
      </motion.div>
    </section>
  );
};
